import { helper } from "@ember/component/helper"
import { get } from "@ember/object"
import type { Capability } from "@shared/models/classifications"
import { includes, isNil } from "lodash-es"

export function hasCapability(args: [any, Capability]) {
  let [model, capability] = args
  if (isNil(model)) return false
  return includes(get(model, "attributes.capabilities"), capability)
}

const hasCapabilityHelper = helper(hasCapability)
export default hasCapabilityHelper

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "has-capability": typeof hasCapabilityHelper
  }
}
